import Api from '@/services/Api'
import store from '@/store/store'
// import { log } from 'util';

export default {
  index(detQuery) {
    return Api().get(`mainledgerdetail/${detQuery}`)
  },
  show(mainledgerdetailid) {
    return Api().get(`mainledgerdetail/${mainledgerdetailid}`)
  },
  post(newmainledgerdetail) {
    return Api().post('mainledgerdetail', newmainledgerdetail)
  },
  // Jedan redak se mijenja izvan ekrana dokumenta (npr. staro povezivanje racuna i uplate),
  // pa ekran dokumenta pri povratku mora ponovno procitati polja veze.
  async put(mainledgerdetail) {
    const odgovor = await Api().put(`mainledgerdetail/${mainledgerdetail.id}`, mainledgerdetail)
    store.commit('oznaciVezePromijenjene')
    return odgovor
  },
  delete(databaseMLID) {
    return Api().delete(`mainledgerdetail/${databaseMLID}`)
  },
  deleteSide(databaseMLID) {
    return Api().delete(`mainledgerside/${databaseMLID}`)
  },
  choose(query) {
    return Api().get('mainledgerdetail/choose', {
      params: query
    })
  },
  saveitems(items) {
    if (items) {
      return Api().post('mainledgerdetail/saveitems', items)
    }
    return
  },
  // Komad velikog dokumenta. Prvi komad se salje preko "saveitems" (zamjenjuje
  // dokument), svaki sljedeci ovuda - "nastavak" samo dodaje, bez brisanja
  // retaka kojih u tom komadu nema.
  saveitemsNastavak(items) {
    if (items) {
      return Api().post('mainledgerdetail/saveitems?nastavak=true', items)
    }
    return
  },
  olditems(query) {
    return Api().get('mainledgerdetailolditems', {
      params: query
    })
  },
  previtems(query) {
    return Api().get('mainledgerdetailprevitems', {
      params: query
    })
  },
  card(query) {
    return Api().get('mainledgerdetailcard', {
      params: query
    })
  },
  findinvoice(query) {
    return Api().get('mainledgerdetailfindinvoice', {
      params: query
    })
  },
  analyze(query) {
    return Api().get('mainledgerdetailanalyze', {
      params: query
    })
  },
}